var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.748,
    height: 27.272,
    viewBox: "0 0 29.748 27.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "premium-svgrepo-com_1_",
    "data-name": "premium-svgrepo-com (1)",
    d: "M25.863,3a.93.93,0,0,1,.753.384l.068.108,4.967,9.313.053.127.014.047.021.1.012.109,0,.123,0-.08a.927.927,0,0,1-.075.367l-.036.074-.05.083-.065.085L17.619,29.906a.9.9,0,0,1-.479.329l-.072.017-.121.017-.073,0-.125-.008-.105-.02-.128-.042-.032-.015a.875.875,0,0,1-.3-.22L2.211,13.818l-.077-.109-.059-.115-.043-.123L2,13.308V13.15l.018-.122.012-.049.042-.119.034-.07,4.959-9.3a.93.93,0,0,1,.693-.483L7.888,3ZM21.717,14.157H12.029l4.847,12.595Zm-11.679,0H4.961L14.1,24.716Zm18.747,0H23.712L19.655,24.708Zm-16.839-9.3h-3.5L4.476,12.3H9.962Zm7.933,0H13.87L11.886,12.3h9.977Zm5.426,0H21.8L23.788,12.3h5.483Z",
    transform: "translate(-2.003 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.b3c420a8273a3c148972fd0401baf98d.svg";
export { ForwardRef as ReactComponent };